'use strict';
/*jshint forin: false */

angular.module('rmEPG')
    .directive('epgSchedule', ['$state', function ($state) {

        let minutesInADay = 1440; // 24x60
        let $document = $(document);
        let actionKeys = {
            46: 'delete',
            68: 'delete',
            88: 'cut',
            67: 'copy',
            86: 'paste',
            65: 'all',
            80: 'publish',
            85: 'unpublish',
            72: 'unpublish',
            27: 'remove-selection',
        };

        function concatBroadcasts(data) {
            let broadcasts = [];

            for (let day in data) {
                broadcasts = broadcasts.concat(data[day].broadcasts);
            }

            return broadcasts;
        }

        function findBroadcastIdsBetween(broadcasts, startId, stopId) {
            if (startId == stopId) {
                return [startId];
            }

            let start = broadcasts.find((b) => b.id == startId);
            let stop = broadcasts.find((b) => b.id == stopId);
            if (start._start > stop._start) {
                let swap = start;
                start = stop;
                stop = swap;
            }

            return broadcasts
                .filter((b) => (b._start > start._start && b._start < stop._start))
                .concat([start, stop])
                .sort((a, b) => a._start > b._start)
                .map((b) => b.id);
        }

        function round(target, num) {
            return Math.round(target / num) * num;
        }

        function ceil(target, num) {
            return Math.ceil(target / num) * num;
        }

        function pixelToMinutes(pixel, height) {
            return Math.round((minutesInADay / height) * pixel);
        }

        function minutesToPixels(minutes, height) {
            return Math.round((height / minutesInADay) * minutes);
        }

        return {
            restrict: 'A',
            scope: {
                zoom: '=epgZoom',
                scrollTo: '=',
                data: '=epgData',
                refresh: '=epgRefreshTrigger',
                onBroadcastDrop: '&',
                onBroadcastBulkDelete: '&',
                onBroadcastBulkPublish: '&',
                onBroadcastBulkPasteCut: '&',
                onBroadcastBulkPasteCopy: '&',
            },
            link: function (scope, element, attrs) {
                scope.$watch('scrollTo', function () {
                    if (!scope.scrollTo) return;

                    setTimeout(() => {
                        let innerHeight = element.find('.epg-broadcasts').height();
                        element.animate({
                            scrollTop: minutesToPixels(scope.scrollTo, innerHeight)
                        }, 400);
                    }, 50); //the timeout makes sure that the zoom is calculated in the dom
                });

                let SNAP = 15;
                scope.$watch('zoom', () => {
                    if (scope.zoom > 150) {
                        SNAP = 5;
                    } else {
                        SNAP = 15;
                    }
                });

                let selected = false;
                let selection = [];
                let CLIPBOARD = []; // Clipboard to hold item IDs
                let CLIPBOARD_ACTION = false; // What to do when pasting
                let focusedDay = false;

                $document.on('click', onClick);
                $document.on('keyup', onKey);

                //element.on('dragstart', onDragStart);
                element.on('dragover', onDragOver);
                element.on('dragend', onDragEnd);
                element.on('drop', onDrop);
                element.on('dragstart', startDragging);
                element.on('mouseover', onMouseOver);
                scope.$watch('refresh', checkSelections);

                scope.$on('$destroy', () => {
                    $document.off('click', onClick);
                    $document.off('keyup', onKey);
                    //element.off('dragstart', onDragStart);
                    element.off('dragover', onDragOver);
                    element.off('dragend', onDragEnd);
                    element.off('drop', onDrop);
                    element.off('dragstart', startDragging);
                    element.off('mouseover', onMouseOver);
                });

                /**
                 * Iterate through all broadcasts to check if its selected
                 *
                 */
                function checkSelections() {
                    let broadcasts = concatBroadcasts(scope.data);
                    broadcasts.forEach((b) => {
                        b._selected = (selection.indexOf(b.id) > -1) ? true : false;
                        b._marked = (CLIPBOARD_ACTION === 'cut' && CLIPBOARD.indexOf(b.id) > -1) ? true : false;
                    });
                }

                function isStartHigher(start, check) {
                    let broadcasts = concatBroadcasts(scope.data);
                    let startBroadcast = broadcasts.find((b) => b.id === start);
                    let checkBroadcast = broadcasts.find((b) => b.id === check);
                    if (startBroadcast === undefined || checkBroadcast === undefined) {
                        return false;
                    }
                    return (startBroadcast._start > checkBroadcast._start);
                }

                function findBroadcast(id) {
                    return concatBroadcasts(scope.data)
                        .find(broadcast => broadcast.id == id);
                }

                let $clicked_target = null;
                let $target = null;
                let $time = null;
                let offset = null;
                let draggingDate = null;
                let broadcast_length = null;
                let remove = true;
                let skippedDrop = true;

                function startDragging(e) {
                    $clicked_target = $(e.target);
                    if (e.ctrlKey || e.shiftKey || e.metaKey || $clicked_target.hasClass('TimeTime')) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                    //e.preventDefault();
                    $target = $clicked_target.clone().attr('dragable', false);
                    let id = $target.data('broadcastId');

                    e.originalEvent.dataTransfer.setData('text/html', 'broadcast_' + id);

                    offset = {
                        top: e.originalEvent.offsetY,
                        left: e.originalEvent.offsetX
                    };
                    $target.css({
                        top: e.pageY - offset.top,
                        left: e.pageX - offset.left,
                        width: $clicked_target.outerWidth()
                    })
                        .addClass('epg-dragging')
                        .appendTo(document.body);
                    $clicked_target.addClass('epg-hidden');
                    $time = $target.find('time');
                    document.body.classList.add('epg-hide-overflow');

                    let broadcast = findBroadcast(id);
                    if (broadcast) {
                        broadcast_length = broadcast._stop.diff(broadcast._start, 'minutes');
                    }

                }

                function onDragOver(e) {
                    let ev = e.originalEvent;
                    let day = $(ev.target).closest('epg-schedule-day');
                    draggingDate = day.data('broadcastDate');
                    ev.preventDefault();

                    let dayOffset = day.offset();
                    let innerHeight = day.find('.epg-broadcasts').height();
                    if (!innerHeight) {
                        return;
                    }

                    let $hoverTarget = $(ev.target);
                    let offsetTop = 0;
                    if ($hoverTarget.hasClass('epg-broadcast') || $hoverTarget.hasClass('TimeTime')) {
                        offsetTop = $hoverTarget.position().top;
                    } else if ($hoverTarget.hasClass('epg-row-heading')) {
                        $time.html('');
                        return;
                    } else {
                        offsetTop = $hoverTarget.position().top + $hoverTarget.parent().position().top;
                    }
                    offsetTop = offsetTop + ev.offsetY - offset.top;
                    if (offsetTop < 0) {
                        return;
                    }

                    $target.css({
                        top: ev.pageY - offset.top,
                        left: dayOffset ? dayOffset.left : ev.pageX - offset.left,
                    });

                    let start = pixelToMinutes(offsetTop, innerHeight);
                    start = round(start, SNAP);
                    start = moment().hours(0).minutes(start);
                    let startFormat = start.format('HH:mm');
                    let stopFormat = start.add(broadcast_length, 'minutes').format('HH:mm');
                    $time.html(startFormat + ' - ' + stopFormat);
                }

                function onDragEnd(e) {


                    if (skippedDrop == true && e){
                        $clicked_target.removeClass('epg-hidden');
                    }


                    if(e){
                        skippedDrop = true;
                    }

                    document.body.classList.remove('epg-hide-overflow');
                    if ($target) {
                        $target.remove();
                    }
                    $target = null;
                    $time = null;
                    offset = null;
                    draggingDate = null;
                    remove = true;
                }

                function onDrop(e) {

                    skippedDrop = false;

                    if (($(element).attr('management-permission')) === 'true') {
                        e.preventDefault();
                        let ev = e.originalEvent;

                        let $eventTarget = $(ev.target);
                        let $broadcasts = $eventTarget.closest('.epg-broadcasts');
                        let innerHeight = $broadcasts.height();
                        if (!innerHeight) {
                            $clicked_target.removeClass('epg-hidden');
                            return;
                        }

                        let offsetTop = 0;

                        if ($eventTarget.hasClass('epg-broadcast') || $eventTarget.hasClass('TimeTime')) {
                            offsetTop = $eventTarget.position().top;
                        } else if ($eventTarget.hasClass('epg-row-heading')) {
                            $time.html('');
                            return;
                        }  else {
                            offsetTop = $eventTarget.position().top + $eventTarget.parent().position().top;
                        }
                        offsetTop = offsetTop + ev.offsetY - offset.top;
                        if (offsetTop < 0) {
                            if (offsetTop < -(offset.top * 1.5)) {
                                return;
                            }
                            offsetTop = 0;
                        }

                        let start = pixelToMinutes(offsetTop, innerHeight);
                        start = round(start, SNAP);

                        let newStart = draggingDate + 'T' + moment().hours(0).minutes(start).format('HH:mm') + ':00';

                        // Keep these in scope
                        remove = false;
                        let ghost = $target.clone().css({
                            position: 'absolute',
                            top: minutesToPixels(start, innerHeight),
                            left: 0,
                            opacity: 0.8
                        }).appendTo($broadcasts);

                        let oldStart = false;
                        let broadcastId = $clicked_target.data('broadcastId');
                        let broadcast = findBroadcast(broadcastId);
                        if (broadcast && broadcast._start) {
                            oldStart = broadcast._start;
                        }

                        scope.onBroadcastDrop({
                            broadcastId: broadcastId,
                            oldStart: oldStart,
                            newStart: newStart,
                            cb: success => {
                                ghost.remove();
                                if (!success) {
                                    $clicked_target.removeClass('epg-hidden');
                                }
                            }
                        });

                        // Sometimes drag end does not fire
                        onDragEnd(false);
                    }
                }

                // Keep tracked over hovered day
                function onMouseOver(e) {
                    let target = $(e.target).closest('epg-schedule-day');
                    if (target.length) {
                        focusedDay = target.data('broadcastDate');
                        if (!target.hasClass('focused') && (CLIPBOARD_ACTION === 'cut' || CLIPBOARD_ACTION === 'copy')) {
                            $('.epg-row.focused').removeClass('focused');
                            target.addClass('focused');
                        }
                    } else {
                        if (focusedDay) {
                            $('.epg-row.focused').removeClass('focused');
                        }
                        focusedDay = false;
                    }
                }

                /**
                 * Handle global selection clicks
                 *
                 */
                function onClick(e) {
                    let $target = $(e.target).closest('.epg-broadcast');
                    if ((e.ctrlKey || e.shiftKey || e.metaKey) && $target.hasClass('epg-broadcast')) {
                        e.preventDefault();
                        let broadcasts = concatBroadcasts(scope.data);

                        if (selected) {
                            if (e.shiftKey) {
                                selection = findBroadcastIdsBetween(broadcasts, selected, $target.data('broadcastId'));
                            } else {
                                let id = $target.data('broadcastId');
                                if (selection.indexOf(id) > -1) {
                                    selection.splice(selection.indexOf(id), 1);
                                    if (selection.length === 0) {
                                        selected = false;
                                    }
                                } else {
                                    if (isStartHigher(selection[0], id)) {
                                        selection.unshift(id);
                                    } else {
                                        selection.push(id);
                                    }
                                }
                            }
                        } else {
                            selected = $target.data('broadcastId');
                            selection = [selected];
                        }

                        scope.$apply(checkSelections);
                    } else if (selected) {
                        concatBroadcasts(scope.data).forEach((b) => b._selected = false);
                        selected = false;
                        selection = [];
                        scope.$apply(checkSelections);
                    }

                }

                /**
                 * Handle selection actions
                 *
                 */
                function onKey(e) {
                    if ($state.is('epg') && actionKeys[e.keyCode] && !window.searching) {
                        switch (actionKeys[e.keyCode]) {
                            case 'all':
                                selection = concatBroadcasts(scope.data).map((b) => b.id);
                                selected = selection[0];
                                scope.$apply(checkSelections);
                                return false;
                            case 'copy':
                            case 'cut':
                                if (selection.length > 0) {
                                    CLIPBOARD = selection.slice();
                                    CLIPBOARD_ACTION = actionKeys[e.keyCode];
                                    scope.$apply(checkSelections);
                                }
                                break;
                            case 'paste':
                                paste();
                                break;
                            case 'delete':
                                if (selection.length > 0) {
                                    scope.onBroadcastBulkDelete({
                                        selection: selection.slice()
                                    });
                                    selection = [];
                                    scope.$apply(checkSelections);
                                }
                                break;
                            case 'publish':
                                if (selection.length > 0) {
                                    scope.onBroadcastBulkPublish({
                                        selection: selection.slice(),
                                        publish: true,
                                    });
                                    selection = [];
                                    selected = false;
                                    scope.$apply(checkSelections);
                                }
                                break;
                            case 'unpublish':
                                if (selection.length > 0) {
                                    scope.onBroadcastBulkPublish({
                                        selection: selection.slice(),
                                        publish: false,
                                    });
                                    selection = [];
                                    selected = false;
                                    scope.$apply(checkSelections);
                                }
                                break;
                            case 'remove-selection':
                                selected = false;
                                selection = [];
                                CLIPBOARD = [];
                                CLIPBOARD_ACTION = null;
                                scope.$apply(checkSelections);
                                focusedDay = null;
                                $('.epg-row.focused').removeClass('focused');
                        }
                    }
                }

                /**
                 * Handle paste action from clipboard
                 *
                 */
                function paste() {
                    if (CLIPBOARD.length > 0) {
                        if (CLIPBOARD_ACTION === 'cut') {
                            scope.onBroadcastBulkPasteCut({
                                pastedDate: focusedDay,
                                selection: CLIPBOARD,
                            });
                            CLIPBOARD = [];
                            CLIPBOARD_ACTION = false;
                        } else if (CLIPBOARD_ACTION === 'copy') {
                            scope.onBroadcastBulkPasteCopy({
                                pastedDate: focusedDay,
                                selection: CLIPBOARD,
                                });
                            }
                        }
                }

            }
        };
    }]);
